<template>
    <div style="padding-bottom:0.7rem">
        <div class="title-box">
            <div class="sub-title">权益介绍</div>
            <div class="title">{{ data.name }}</div>
            <p class="unlock_tip" v-if="!isSatisfied">未满足，需创作等级≥K{{ data.minLevel }}</p>
        </div>

        <div v-if="isSatisfied">
            <div v-for="(item, index) in data.detailRule" :key="index" style="margin-bottom:0.48rem">
                <p class="rule-title">{{ item.title }}</p>
                <div v-for="(detail, index) in item.body" :key="index" class="rule-desc-box">
                    <p class="rule-desc">
                        {{ detail.text }}
                    </p>
                    <img :src="detail.img" v-if="detail.img" class="rule-img" @Click="() => onClickImg(detail.img)" />
                </div>
            </div>
        </div>
        <div v-else>
            <p class="rule-title">权益说明</p>
            <p class="rule-desc">{{ data.description }}</p>
        </div>
        <div v-if="showImgDetail" class="modal" @click="showImgDetail = false">
            <img :src="imgUrl" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'benefit-intro',
    props: {
        data: {
            type: Object,
            required: true,
        },
        isSatisfied: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            imgUrl: '',
            showImgDetail: false,
        };
    },
    methods: {
        onClickImg(url) {
            console.log('xxxxonClickImg', url);
            this.imgUrl = url;
            this.showImgDetail = true;
        },
    },
};
</script>

<style lang="less" scoped>
.title-box {
    margin-bottom: 0.4rem;
    padding-bottom: 0.4rem;
    border-bottom: 0.01rem solid rgba(255, 255, 255, 0.08);
}
.sub-title {
    font-weight: 400;
    font-size: 0.22rem;
    line-height: 0.32rem;
    color: rgba(255, 255, 255, 0.4);
    margin-bottom: 0.24rem;
}
.title {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 500;
    font-size: 0.42rem;
    line-height: 0.58rem;
    color: rgba(255, 255, 255, 0.9);
}
.rule-title {
    font-weight: 500;
    font-size: 0.26rem;
    line-height: 0.36rem;
    color: #ffffff;
    margin-bottom: 0.24rem;
}
.rule-desc-box {
    margin-top: 0.18rem;
}
.rule-desc {
    font-weight: 400;
    font-size: 0.26rem;
    line-height: 0.36rem;
    color: rgba(255, 255, 255, 0.4);
}
.rule-img {
    width: 3rem;
    height: 3rem;
    object-fit: contain;
    margin-top: 0.32rem;
}
.modal {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.7);
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}
.unlock_tip {
    font-size: 0.22rem;
    line-height: 0.3rem;
    color: rgba(247, 54, 93, 0.9);
    background: rgba(247, 54, 93, 0.08);
    border-radius: 0.2rem;
    padding: 0.06rem 0.2rem;
    display: inline-block;
    margin-top: 0.18rem;
}
</style>
